<template>
    <transition name="fade">
        <div class="mask" v-show="visible">
            <div class="popup"
                :style="{
                    backgroundImage: `url(${mainPic})`
                }">
            </div>
            <button class="btn" @click="next"></button>
        </div>
    </transition>
</template>

<script>
import gameInfo from '../assets/gameInfo';

export default {
    data() {
        return {
            visible: false,
            name: 'tianjin'
        };
    },
    computed: {
        mainPic() {
            const info = gameInfo[this.name];
            return info.mainPic;
        }
    },
    methods: {
        show() {
            this.visible = true;
        },
        hide() {
            this.visible = false;
        },
        next() {
            this.$emit('changeBgAudio', 'gamebgm');
            this.$router.push('/guessdifferent/level');
        }
    }
};
</script>
<style lang='stylus' scoped>
.fade-enter-active, .fade-leave-active
    transition opacity .3s
.fade-enter, .fade-leave-to
    opacity 0
.mask
    size 100%
    position fixed
    top 0
    background-color rgba(0,0,0,.7)
    .popup
        size 5.5rem 8.1rem
        background-size 100% 100%
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
    .btn
        size 2rem .8rem
        background url('../assets/img/btn_start.png') center/1.87rem .34rem no-repeat
        position absolute
        bottom 7%
        left 50%
        transform translateX(-50%)
        z-index 500
</style>
